import React, { PureComponent } from 'react';
import injectSheet from 'react-jss';
import { Button, Input, Modal, Table, Form, Row, Col, Tooltip } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Router, Link } from 'src/routes';
import styles from './styles';
import PropTypes from 'prop-types';
import { changeAccount, logoutRequest, loginRequest, loginAccountAssociated } from 'src/redux/actions/auth';
import AuthStorage from 'src/utils/AuthStorage';
import { isNull } from 'lodash';

function mapStateToProps(state) {
	return {
		store: {
			auth: state.auth
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				changeAccount,
				logoutRequest,
				loginRequest,
				loginAccountAssociated
			},
			dispatch
		)
	};
};
const FormItem = Form.Item;
@connect(
	mapStateToProps,
	mapDispatchToProps
)
@injectSheet(styles)

@Form.create()
export default class BtnChangeAccount extends PureComponent {
	static propTypes = {
		store: PropTypes.shape({
			auth: null
		}).isRequired,
		action: PropTypes.shape({
			// loginRequest: PropTypes.func.isRequired,
			loginAccountAssociated: PropTypes.func.isRequired
		}).isRequired
	};
	state = {
		isModalVisible: false,
		isModalConfirmVisible: false,
		buttonVisible: false,
		associateAccount: '',
		dataAccount: [],
		valuePassword: '',
		loading: false,
		userIdAssociated: ''
	};
	async componentDidMount() {

		this.getListPartner()
	}
	getListPartner = () => {
		this.props.action.changeAccount(
			{ pagination: false },
			res => {
				this.setState({
					dataAccount: res['user_partner']
				});
			},
		);
	}

	handleModalAccount = (payload = {}) => {
		this.setState({ isModalVisible: true })
	};

	handleChangeAccount = (e) => {
		this.setState({ isModalConfirmVisible: true, associateAccount: e.email, userIdAssociated: e.userId })
	}

	handleSubmit = e => {
		e.preventDefault();
		const { setFields } = this.props.form;
		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({
					loading: true
				});
				this.props.action.loginAccountAssociated(
					{
						username: this.state.associateAccount.replace(/\s/g, ''),
						password: values.password
					},

					() => {
						window.location.reload();
						this.setState({
							loading: false
						});
					},

					() => {
						const { error } = this.props.store.auth;
						if (error.statusCode === 603) {
							message.error('Votre compte a été désactivé');
						}

						if (error.statusCode === 602) {
							setFields({
								username: {
									value: values.username,
									errors: [new Error(error.message || '')]
								}
							});
						}

						if (error.statusCode === 601) {
							setFields({
								password: {
									value: values.password,
									errors: [new Error("L'identifiant ou le mot passe est incorrect" || '')]
								}
							});
						}
						this.setState({
							loading: false,
						});

					},

				)
			}

		});
	};

	render() {
		const { dataAccount, loading } = this.state;
		const { classes } = this.props;
		const { getFieldDecorator } = this.props.form;
		
		const { isTama, isCompany, isRestaurant, isEmployee, idInfo, email } = AuthStorage;
		const column = [
			{
				dataIndex: '',
				key: '',
				width: '70%',
				render: (e) => {
					return (
						isRestaurant && (
							<>
							<Tooltip
								placement="top"
								title={
									<span style={{ color: '#16C68F', fontSize: 12 }}>
										{e.email}
									</span>}>
								<span style={{ color: '#16C68F', fontSize: 16 }}>{e.restaurantName}</span>
							</Tooltip>
						</>
						)
						
						||

						isCompany && (
							<>
							<Tooltip
								placement="top"
								title={
									<span style={{ color: '#16C68F', fontSize: 12 }}>
										{e.email}
									</span>}>
								<span style={{ color: '#16C68F', fontSize: 16 }}>{e.companyName}</span>
							</Tooltip>
						</>
						)
					)
				}
			},
			{
				align: 'left',
				render: (e) => {
					return (
						<Button
							width={"100%"}
							onClick={() => this.handleChangeAccount(e)}>
							Se connecter
						</Button>
					)
				}
			}
		];
		const dataSource = dataAccount && dataAccount.map(d => ({
			...d,
			userInfo: isRestaurant ? `${d.firstName} ${d.lastName}` : `${d.name}`
		}));

		return (
			<>

				{/* MODAL COMPTES ASSOCIÉS */}
				<Modal
					title="Vos comptes associés"
					visible={this.state.isModalVisible}
					cancelText="Fermer"
					okButtonProps={{ style: { display: 'none' } }}
					onCancel={() => this.setState({ isModalVisible: false })}
					width={800}
				>
					<Table
						locale={{ emptyText: "Vous n'avez aucun compte associé" }}
						rowKey={record => record.id}
						columns={column}
						scroll={{ y: '60vh', x: '100%' }}
						hideSelectAll={true}
						dataSource={dataSource}
						showHeader={false}
						showFooter={false}
						pagination={false}
					/>
				</Modal>

				<Button type="link" onClick={this.handleModalAccount} style={{ width: '100%', textAlign: 'left' }}>
					Changer de compte
				</Button>

				<Modal
					title="Connexion"
					visible={this.state.isModalConfirmVisible}
					cancelText="Annuler"
					okButtonProps={{ style: { display: 'none' } }}
					onCancel={() => this.setState({ isModalConfirmVisible: false })}
				>
					<Form onSubmit={this.handleSubmit} className="login-form">
						<FormItem
							label={"Confirmer le mot de passe du compte: "}
							className={classes.input}>
							{getFieldDecorator('password', {
								rules: [{ required: true, message: 'Champs obligatoires' }]
							})(
								<Input.Password
									// prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
									type="password"
									size="large"
									placeholder="Mot de passe"
								/>
							)}
						</FormItem>
						<FormItem>
							<Row type="flex" justify="space-between">
								<Col>
									<Button
										type="primary"
										size="large"
										htmlType="submit"
										className={classes.btnLogin}
										loading={loading}>
										Changer de compte
									</Button>
								</Col>
							</Row>
						</FormItem>
					</Form>
				</Modal>
			</>
		);
	}
}
